export class LoadingItemTemplate {
  id: number;
  pos: number;
  productID: number;
  qty: number;
  loadNumber: string;
  extNr1: string;
  extNr2: string;
  vehicleID: number;
  compartmentID: number;

  static fromLoadingItem(loadingItem) {
    let loadingItemTemplate = new LoadingItemTemplate();
    Object.assign(loadingItemTemplate, {
      id: 0,
      pos: loadingItem.pos,
      productID: loadingItem.productID,
      qty: loadingItem.qty,
      loadNumber: loadingItem.loadNumber,
      extNr1: loadingItem.extNr1,
      extNr2: loadingItem.extNr2,
      vehicleID: loadingItem.vehicleID,
      compartmentID: loadingItem.compartmentID,
      product: { ...loadingItem.product }
    });
    return loadingItemTemplate;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/loading-item-template.ts